export const access_user = 'a484b20b-34ba-4a6d-b451-446b89c155d4'
export const access_rights = '6da858c1-2310-47cb-b6d5-35c2b896b685'
export const access_roles = 'fa758dd4-eee7-4f01-a7b4-950f180c2a40'
export const view_admin_dashboard = '27c683dd-ab0d-474a-933a-5535e0eacf0d'
export const access_parameters = '28955164-8099-43c7-91f5-d125dd90977b'
export const access_projects = '2794dc3f-b2c4-45b3-83bf-5ea34576aa88'
export const access_registrations = '8f848a98-46f1-450d-82f3-110da73e70f6'
export const access_reports = '0cc68b9c-9ab6-4727-be7c-9cf638eaac84'
export const access_skills = '33343f84-08f4-4709-8bc1-dbde18808eb3'
export const access_rates = 'a55c1f31-7143-4a94-8491-76594fd342a7'
export const export_excel_list = '9ddbc7df-e26d-44aa-bef5-d91f213168c6'



